import { Observer } from "mobx-react-lite"
import React from "react"
import { single_quote, quote_item_name } from "../../shared/quotedata/index"
import { store } from "./store"

export function BondNotice() {
  return (
    <Observer>
      {() => (
        <ul className="zq-notice">
          <li>
            <span>匹配成交价</span>
            {single_quote[quote_item_name.匹配成交价](store.StockDetail).element}
          </li>
          <li>
            <span>匹配成交涨幅</span>
            {single_quote[quote_item_name.匹配成交涨幅](store.StockDetail).element}
          </li>
          <li>
            <span>匹配成交量</span>
            {single_quote[quote_item_name.匹配成交量](store.StockDetail).element}
          </li>
          <li>
            <span>匹配成交额</span>
            {single_quote[quote_item_name.匹配成交额](store.StockDetail).element}
          </li>
        </ul>
      )}
    </Observer>
  )
}
